import * as _ from 'underscore';

angular.module('vastdesk').
  component('modifierDaypartingTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      dayParting: '<'
    },
  template: require("../templates/modifierDaypartingTargeting.html"),
    controllerAs: '$modifierDaypartingTargetingCtrl',
    controller: ['$scope', '$timeout', '$element', function($scope, $timeout, $element) {
      const self = this;

      /**
       * Keeps a separate copy of the dayparting values while they're being edited to allow them to be reverted
       * @type {Array<Array<boolean>>}
       */
      this.modalDayParting = Array.from({ length: 7 }, (_v, day) => Array.from( { length: 24 }, (_v, hour) => !!_.get(self.dayParting, [day, hour], false)));
      /** Keeps a separate copy of the user timezone value to allow it to be reverted */
      this.usersTimezone = true;
      this.modalUsersTimezone = true;
      this.multipleTimeOfDayRules = false;

      this.dayPartingInputNameFor = function(day, hour) {
        return self.formName + '[day_parting][' + day + '][' + hour + ']';
      };

      // single field on modifier affects all rules
      const findUsersTimezoneInput = function() {
        return $element.closest('form').find('input[name$="modifier[day_parting_users_timezone]"]');
      };

      const refreshUsersTimezoneFromInput = function() {
        const $input = findUsersTimezoneInput();
        self.usersTimezone = $input.length ? $input.val() !== 'false' : true;
        resetTemporaryModalValues();
      };

      const onUsersTimezoneInputChange = function() {
        $timeout(function() {
          self.usersTimezone = findUsersTimezoneInput().val() !== 'false';
        });
      };

      const countDaypartingRules = function() {
        const $visibleRuleGroups = $element.closest('form').find('.modifier-rules.associationGroup:not([style*="display: none"])').not('.hidden');

        return $visibleRuleGroups.find('select[name$="[modifier_rule_object]"]').filter(function() {
          return $(this).val() === 'Dayparting';
        }).length;
      };

      $element.on("click", ".open-dayparting-modal", function() {
        refreshUsersTimezoneFromInput();

        self.multipleTimeOfDayRules = countDaypartingRules() > 1;

        $element.find(".day-parting-modal").modal();
      });

      $element.on('click', '.day-parting-modal #modal_save', function() {
        $element.find(".day-parting-modal").modal('hide');

        $timeout(function() {
          $scope.$apply();
        });
      });

      const resetTemporaryModalValues = function() {
        // make a copy of dayParting to allow users to confirm changes before applying them to the form this component is embedded in
        for (let day = 0; day < 7; ++day) {
          for (let hour = 0; hour < 24; ++hour) {
            self.modalDayParting[day][hour] = !!(Array.isArray(self.dayParting) && self.dayParting[day] && self.dayParting[day][hour]);
          }
        }

        self.modalUsersTimezone = self.usersTimezone;

        $timeout(() => { $scope.$apply(); });
      };

      const save = function() {
        const uniqueValues = _.chain(self.modalDayParting).flatten().uniq().value();

        if (uniqueValues.length > 1) {
          self.dayParting = angular.copy(self.modalDayParting);
          self.usersTimezone = self.modalUsersTimezone;
        } else {
          self.dayParting = [];
          resetTemporaryModalValues();
        }

        findUsersTimezoneInput().val(self.modalUsersTimezone ? 'true' : 'false').trigger('change');
      };

      // make this component load the dayparting text which we display under the "All", "Custom", "Edit" buttons
      $element.on('click', '.day-parting-modal #modal_save', save);
      $element.on('click', '.day-parting-modal .modal_cancel', resetTemporaryModalValues);

      this.$onInit = function() {
        $timeout(function() {
          refreshUsersTimezoneFromInput();

          findUsersTimezoneInput().on('change.modifierDaypartingTargeting', onUsersTimezoneInputChange);
        });
      };

      $scope.$on('$destroy', function() {
        findUsersTimezoneInput().off('change.modifierDaypartingTargeting', onUsersTimezoneInputChange);
      });
    }]
});
